const PLATFORMS = [
  {
    id: 'dponet',
    name: 'DPOnet',
  },
  {
    id: 'advisor',
    name: 'Advisor',
  },
  {
    id: 'both',
    name: 'DPOnet e Advisor',
  },
]

const SAML_PROVIDERS = [
  {
    id: 'zitadel',
    name: 'DPOnet SSO',
  },
  {
    id: 'ssoready',
    name: 'SSOReady',
    disabled: true,
  },
]

const IDP_PROVIDERS = [
  {
    id: 'entra_id',
    name: 'Entra ID (Microsoft)',
  },
  {
    id: 'google',
    name: 'Google',
  },
  {
    id: 'generic',
    name: 'Outro',
  },
]

const ssoCorporateGroups = {
  PLATFORMS,
  SAML_PROVIDERS,
  IDP_PROVIDERS,
}

export default ssoCorporateGroups
